export const MS_DIA = 86_400_000;

export function hojeEmSaoPaulo(agora: Date = new Date()): string {
  const partes = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(agora);
  const parte = (tipo: Intl.DateTimeFormatPartTypes): string =>
    partes.find((p) => p.type === tipo)?.value ?? '';
  return `${parte('year')}-${parte('month')}-${parte('day')}`;
}

/**
 * Mínimo de vencimento de pendência. É amanhã, não hoje: o vencimento é gravado à
 * meia-noite UTC do dia escolhido, então "hoje" nasce com o instante já vencido e a
 * varredura das 20h (SP) expira a pendência na mesma noite — notificando as partes
 * sem rota de desfazer.
 */
export function amanhaEmSaoPaulo(agora: Date = new Date()): string {
  const hoje = new Date(`${hojeEmSaoPaulo(agora)}T00:00:00.000Z`);
  return new Date(hoje.getTime() + MS_DIA).toISOString().slice(0, 10);
}

export function anosAlcancaveisPeloPrazo(hoje: string, maiorAtalhoDiasUteis: number): number[] {
  const inicio = new Date(`${hoje}T00:00:00.000Z`);
  const limite = new Date(inicio.getTime() + maiorAtalhoDiasUteis * 2 * MS_DIA);
  const anoInicial = inicio.getUTCFullYear();
  const anoFinal = limite.getUTCFullYear();
  if (anoFinal === anoInicial) return [anoInicial];
  return [anoInicial, anoFinal];
}
